import { Portal } from "@chakra-ui/react";
import { useState } from "react";
import { useHistory, useLocation, useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import AddCustomer from "./AddCustomer";
import CustomerList from "./customerList";
import AdminNavbar from "components/Navbars/AdminNavbar";

const ClientContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch(); // e.g. /client
  const [editingCustomer, setEditingCustomer] = useState(null);

  // Detect current view from path
  const isAdd = location.pathname.endsWith("/add");
  const isEdit = location.pathname.includes("/edit");

  // ✨ Breadcrumbs logic
  const breadcrumbs = [
    {
      label: "Πελάτες",
      onClick: () => history.push(match.url),
      isClickable: isAdd || isEdit,
      isCurrent: !(isAdd || isEdit),
    },
    ...(isAdd || isEdit
      ? [
        {
          label: isEdit ? "Επεξεργασία Πελάτη" : "ΠΡΟΣΘΗΚΗ ΠΕΛΑΤΗ",
          isClickable: false,
          isCurrent: true,
        },
      ]
      : []),
  ];

  const handleAddClient = () => {
    history.push(`${match.url}/add`);
  };

  const handleEdit = (customer) => {
    localStorage.setItem("customerData", JSON.stringify(customer)); // Store in localStorage
    setEditingCustomer(customer);
    history.push(`${match.url}/edit/${customer.id}`);
  };


  const handleDelete = (customer) => {
    console.log("Delete clicked for:", customer);
  };

  const onAddCustomerStatus = (status) => {
    if (status === true) {
      history.push(match.url);
    }
  };

  return ( 
    <>
      <Portal>
        <AdminNavbar logoText="ΚΡΕΑΡΙΣΤΟΝ" breadcrumbs={breadcrumbs} />
      </Portal>

      <Switch>
        <Route exact path={match.path}>
          <CustomerList
            handleAddClient={handleAddClient}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </Route>

        <Route exact path={`${match.path}/add`}>
          <AddCustomer
            customerData={null}
            onAddCustomerStatus={onAddCustomerStatus}
          />
        </Route>

        <Route exact path={`${match.path}/edit/:id`}>
          <AddCustomer
            customerData={
              editingCustomer || JSON.parse(localStorage.getItem("customerData"))
            }
            onAddCustomerStatus={onAddCustomerStatus}
          />
        </Route>


        {/* Fallback to customer list for unknown routes */}
        <Redirect to={match.url} />
      </Switch>
    </>
  );
};

export default ClientContainer;
